module.exports = __webpack_public_path__ + "img/image17.d503ee15.webp";